import { Problema } from '@soap/aside/types/ProblemaModel'

export const problemaMatchesFilter = (filter: string, problema: Problema) =>
  (problema.ciap && (problema.ciap.codigo.includes(filter) || problema.ciap.descricao.includes(filter))) ||
  (problema.cid10 && (problema.cid10.codigo.includes(filter) || problema.cid10.nome.includes(filter))) ||
  (problema.cid11 && (problema.cid11.codigo.includes(filter) || problema.cid11.nome.includes(filter))) ||
  problema.descricaoOutro?.includes(filter)
